function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { motion, AnimatePresence } from 'framer-motion';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import Offline from 'svg/offline.svg';
import X from 'svg/x.svg';
import { useNetworkStatus, useCountdown } from 'hooks';
import Button from 'components/Form/Button';
import messages from '../../messages';
import styles from './OfflineOverlay.pcss';
const OfflineOverlay = ()=>{
    useStyles(styles);
    const isOnline = useNetworkStatus();
    const isOnlineRef = useRef(isOnline);
    const [isIgnored, setIsIgnored] = useState(false);
    const { seconds: tryAgainSeconds, isRunning: isTryAgainCounting, start: startCountdown, reset: resetCountdown } = useCountdown(5);
    const onIgnore = ()=>{
        setIsIgnored(true);
        resetCountdown();
    };
    useEffect(()=>{
        if (isOnline && !isOnlineRef.current) {
            setIsIgnored(false);
            resetCountdown();
        }
        isOnlineRef.current = isOnline;
    }, [
        isOnline
    ]);
    if (isOnline === undefined || isOnline || isIgnored) return null;
    const onTryAgain = ()=>{
        startCountdown();
    };
    const CloseBtn = /*#__PURE__*/ _jsx("div", {
        className: "modal__close",
        children: /*#__PURE__*/ _jsx("button", {
            "aria-label": "X",
            type: "button",
            className: "modal__close__btn",
            onClick: onIgnore,
            children: /*#__PURE__*/ _jsx("span", {
                className: "btn-inner",
                children: /*#__PURE__*/ _jsx(X, {
                    className: "modal__close__btn__icon"
                })
            })
        })
    });
    const Header = /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("h2", {
            className: "modal__header brand__h1",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.offline))
        })
    });
    const ActionButtons = /*#__PURE__*/ _jsxs("div", {
        className: "row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.ignore,
                    className: "btn--block",
                    onClick: onIgnore
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    className: "btn--filled btn--block",
                    onClick: onTryAgain,
                    children: isTryAgainCounting ? tryAgainSeconds : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.tryAgain))
                })
            })
        ]
    });
    const Content = /*#__PURE__*/ _jsx("div", {
        className: cn('modal__contentWrapper'),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "modal__content",
            children: [
                Header,
                /*#__PURE__*/ _jsx("p", {
                    className: "brand__paragraph--bold",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.offline))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.offline__container,
                    children: /*#__PURE__*/ _jsx(Offline, {})
                }),
                ActionButtons
            ]
        })
    });
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        children: /*#__PURE__*/ _jsxs(motion.div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                ease: 'easeOut',
                duration: 0.15
            },
            className: cn('modal modal--sm'),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "body-overlay",
                    role: "presentation"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "modal__container",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "modal__body",
                        children: [
                            CloseBtn,
                            Content
                        ]
                    })
                })
            ]
        })
    });
};
export default OfflineOverlay;
